export var MPAEntityType;
(function (MPAEntityType) {
    MPAEntityType["MPA_ENTITY_TYPE_UNSPECIFIED"] = "MPA_ENTITY_TYPE_UNSPECIFIED";
    MPAEntityType["MPA_ENTITY_TYPE_SNAPSHOT"] = "MPA_ENTITY_TYPE_SNAPSHOT";
    MPAEntityType["MPA_ENTITY_TYPE_CLOUD_RESOURCE"] = "MPA_ENTITY_TYPE_CLOUD_RESOURCE";
    MPAEntityType["MPA_ENTITY_TYPE_BACKUP_POLICY"] = "MPA_ENTITY_TYPE_BACKUP_POLICY";
    MPAEntityType["MPA_ENTITY_TYPE_SAAS_USER_MAILBOX"] = "MPA_ENTITY_TYPE_SAAS_USER_MAILBOX";
    MPAEntityType["MPA_ENTITY_TYPE_SAAS_USER_DRIVE"] = "MPA_ENTITY_TYPE_SAAS_USER_DRIVE";
    MPAEntityType["MPA_ENTITY_TYPE_SAAS_GROUP"] = "MPA_ENTITY_TYPE_SAAS_GROUP";
    MPAEntityType["MPA_ENTITY_TYPE_SAAS_SHARED_DRIVE"] = "MPA_ENTITY_TYPE_SAAS_SHARED_DRIVE";
    MPAEntityType["MPA_ENTITY_TYPE_SAAS_SITE"] = "MPA_ENTITY_TYPE_SAAS_SITE";
    MPAEntityType["MPA_ENTITY_TYPE_SAAS_USER"] = "MPA_ENTITY_TYPE_SAAS_USER";
})(MPAEntityType || (MPAEntityType = {}));
